export default __webpack_public_path__ + "static/avatar-dont-3-dark-5396b4cd71a0ed2bc7a59dabeca855bb.png";